import { NgModule } from '@angular/core';
import { ScullyLibModule } from '@scullyio/ng-lib';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { BlogsComponent } from './blogs.component';
import { SharedModule } from 'app/shared/shared.module';
import { BlogRoutingModule } from './blogs-routing.module';
import { BlogDetailComponent } from './blog-detail/blog-detail.component';
import { IconsModule } from 'app/icons/icons.module';

@NgModule({
	imports: [ScullyLibModule, LazyLoadImageModule, SharedModule, BlogRoutingModule, IconsModule],
	exports: [],
	declarations: [BlogsComponent, BlogDetailComponent],
	providers: [],
})
export class BlogsModule {}
/**
 * Ng Module
 */
